__turbopack_context__.v({
  "content": "SEf-Ta_content",
  "iconWrapper": "SEf-Ta_iconWrapper",
  "label": "SEf-Ta_label",
  "root": "SEf-Ta_root",
  "stat": "SEf-Ta_stat",
  "value": "SEf-Ta_value",
});
